"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportStepStatus = exports.ExportProgress = exports.ExportSystem = exports.ExportCode = void 0;
var ExportCode;
(function (ExportCode) {
    ExportCode["CSV"] = "csv";
    ExportCode["WEBHOOK"] = "webhook";
    ExportCode["STATIC_CSV"] = "static_csv";
    ExportCode["ZENGIN_CSV"] = "zengin_csv";
    /** @deprecated use CONCUR_INVOICE */
    ExportCode["CONCUR"] = "concur";
    ExportCode["CONCUR_INVOICE"] = "concur_invoice";
    /** @deprecated use INFOMART_INVOICE_DETAIL or INFOMART_INVOICE_MAKEACC */
    ExportCode["INFOMART_INVOICE"] = "infomart_invoice";
    ExportCode["INFOMART_INVOICE_DETAIL"] = "infomart_invoice_detail";
    ExportCode["INFOMART_INVOICE_MAKEACC"] = "infomart_invoice_makeacc";
    ExportCode["OBC"] = "obc";
    ExportCode["COUPA_INVOICE"] = "coupa_invoice";
    ExportCode["COUPA_CREDIT_NOTE"] = "coupa_credit_note";
    ExportCode["ARIBA_INVOICE"] = "ariba_invoice";
})(ExportCode = exports.ExportCode || (exports.ExportCode = {}));
var ExportSystem;
(function (ExportSystem) {
    ExportSystem["CSV"] = "csv";
    ExportSystem["WEBHOOK"] = "webhook";
    ExportSystem["STATIC_CSV"] = "static_csv";
    ExportSystem["ZENGIN_CSV"] = "zengin_csv";
    ExportSystem["CONCUR"] = "concur";
    ExportSystem["INFOMART"] = "infomart";
    ExportSystem["OBC"] = "obc";
    ExportSystem["COUPA"] = "coupa";
    ExportSystem["ARIBA"] = "ariba";
})(ExportSystem = exports.ExportSystem || (exports.ExportSystem = {}));
exports.ExportProgress = {
    WAITING: 1,
    RUNNING: 2,
    DONE: 3,
    ERROR: 4,
};
exports.ExportStepStatus = {
    RUNNING: 2,
    DONE: 3,
    ERROR: 4,
};
